interface HttpDataModel {
  url: string;
  urlExperienceApi?: string;
  expBaseUrl?: string;
  partitionTree?: string;
  other: any
}
export default {
  url: process.env.REACT_APP_URL,
  other: {}
} as HttpDataModel

